import type { InputFieldDefinition } from "../../renderer.types.ts";
import {
  appendHelpText,
  applyLengthValidation,
  createControlLabel,
  createFieldScaffold,
  createTextInput,
} from "../shared.ts";
import type { NativeInputType, RenderContext } from "../types.ts";

/** Applies field-type-specific validation attributes to an already-built input. */
export type InputValidator = (input: HTMLInputElement) => void;

/**
 * Renders a text-like field with its caller-declared native input `type`.
 *
 * Shared length validation is applied first, then the caller's type-specific
 * validator runs so each handler only owns its unique attributes.
 */
export const renderTextLikeField = (
  field: InputFieldDefinition,
  context: RenderContext,
  inputType: NativeInputType,
  applyTypeValidation?: InputValidator,
): HTMLElement => {
  const scaffold = createFieldScaffold(field, context);
  const label = createControlLabel(field.label, field.required, scaffold.inputId);
  const input = createTextInput(field, scaffold.inputId, scaffold.helpId, inputType);

  applyLengthValidation(input, field);
  applyTypeValidation?.(input);

  scaffold.wrapper.append(label, input);
  appendHelpText(scaffold, field);

  return scaffold.wrapper;
};
